// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LangRouteRouteImport } from './routes/$lang/route'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as LlmsDottxtRouteImport } from './routes/llms[.]txt'
import { Route as SitemapDotxmlRouteImport } from './routes/sitemap[.]xml'
import { Route as LangIndexRouteImport } from './routes/$lang/index'
import { Route as LangCookiebeleidRouteImport } from './routes/$lang/cookiebeleid'
import { Route as LangNieuwbouwRouteImport } from './routes/$lang/nieuwbouw'
import { Route as LangOfferteRouteImport } from './routes/$lang/offerte'
import { Route as LangOpbouwZwembadRouteImport } from './routes/$lang/opbouw-zwembad'
import { Route as LangOverOnsRouteImport } from './routes/$lang/over-ons'
import { Route as LangPrivacybeleidRouteImport } from './routes/$lang/privacybeleid'
import { Route as LangRenovatieRouteImport } from './routes/$lang/renovatie'
import { Route as LangSitemapRouteImport } from './routes/$lang/sitemap'
import { Route as LangTechniekenRouteImport } from './routes/$lang/technieken'
import { Route as LangWarmtepompenAfdekkingenRouteImport } from './routes/$lang/warmtepompen-afdekkingen'
import { Route as AuthIndexRouteImport } from './routes/auth/index'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as UploadTokenRouteImport } from './routes/upload/$token'
import { Route as LangBlogIndexRouteImport } from './routes/$lang/blog/index'
import { Route as LangBlogSlugRouteImport } from './routes/$lang/blog/$slug'
import { Route as LangRealisatiesIndexRouteImport } from './routes/$lang/realisaties/index'
import { Route as LangRealisatiesSlugRouteImport } from './routes/$lang/realisaties/$slug'
import { Route as AuthenticatedAdminAanvragenRouteImport } from './routes/_authenticated/admin/aanvragen'
import { Route as AuthenticatedAdminFeedbackRouteImport } from './routes/_authenticated/admin/feedback'
import { Route as AuthenticatedAdminFotoInstellingenRouteImport } from './routes/_authenticated/admin/foto-instellingen'
import { Route as AuthenticatedAdminFotoOrdenenRouteImport } from './routes/_authenticated/admin/foto-ordenen'
import { Route as AuthenticatedAdminFotosRouteImport } from './routes/_authenticated/admin/fotos'
import { Route as AuthenticatedAdminGebruikersRouteImport } from './routes/_authenticated/admin/gebruikers'
import { Route as AuthenticatedAdminPagespeedRouteImport } from './routes/_authenticated/admin/pagespeed'
import { Route as AuthenticatedAdminStatistiekenRouteImport } from './routes/_authenticated/admin/statistieken'
import { Route as AuthenticatedAdminVitalsRouteImport } from './routes/_authenticated/admin/vitals'
import { Route as ApiPublicAnalyticsRouteImport } from './routes/api/public/analytics'
import { Route as ApiPublicAnalyticsCronRouteImport } from './routes/api/public/analytics-cron'
import { Route as ApiPublicPageAuditRouteImport } from './routes/api/public/page-audit'
import { Route as ApiPublicVitalsRouteImport } from './routes/api/public/vitals'
import { Route as ApiPublicVitalsRollupRouteImport } from './routes/api/public/vitals-rollup'
import { Route as LangRealisatiesGemeenteGemeenteRouteImport } from './routes/$lang/realisaties/gemeente/$gemeente'
import { Route as AuthenticatedAdminArtikelsIndexRouteImport } from './routes/_authenticated/admin/artikels/index'
import { Route as AuthenticatedAdminArtikelsSlugRouteImport } from './routes/_authenticated/admin/artikels/$slug'
import { Route as AuthenticatedAdminPaginasIndexRouteImport } from './routes/_authenticated/admin/paginas/index'
import { Route as AuthenticatedAdminPaginasSleutelRouteImport } from './routes/_authenticated/admin/paginas/$sleutel'
import { Route as AuthenticatedAdminRealisatiesIndexRouteImport } from './routes/_authenticated/admin/realisaties/index'
import { Route as AuthenticatedAdminRealisatiesSlugRouteImport } from './routes/_authenticated/admin/realisaties/$slug'
import { Route as ApiPublicBlogImageSplatRouteImport } from './routes/api/public/blog-image/$'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const LangRouteRoute = LangRouteRouteImport.update({
            id: '/$lang',path: '/$lang',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const LlmsDottxtRoute = LlmsDottxtRouteImport.update({
            id: '/llms.txt',path: '/llms.txt',getParentRoute: () => rootRouteImport
          })
const SitemapDotxmlRoute = SitemapDotxmlRouteImport.update({
            id: '/sitemap.xml',path: '/sitemap.xml',getParentRoute: () => rootRouteImport
          })
const LangIndexRoute = LangIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LangRouteRoute
          })
const LangCookiebeleidRoute = LangCookiebeleidRouteImport.update({
            id: '/cookiebeleid',path: '/cookiebeleid',getParentRoute: () => LangRouteRoute
          })
const LangNieuwbouwRoute = LangNieuwbouwRouteImport.update({
            id: '/nieuwbouw',path: '/nieuwbouw',getParentRoute: () => LangRouteRoute
          })
const LangOfferteRoute = LangOfferteRouteImport.update({
            id: '/offerte',path: '/offerte',getParentRoute: () => LangRouteRoute
          })
const LangOpbouwZwembadRoute = LangOpbouwZwembadRouteImport.update({
            id: '/opbouw-zwembad',path: '/opbouw-zwembad',getParentRoute: () => LangRouteRoute
          })
const LangOverOnsRoute = LangOverOnsRouteImport.update({
            id: '/over-ons',path: '/over-ons',getParentRoute: () => LangRouteRoute
          })
const LangPrivacybeleidRoute = LangPrivacybeleidRouteImport.update({
            id: '/privacybeleid',path: '/privacybeleid',getParentRoute: () => LangRouteRoute
          })
const LangRenovatieRoute = LangRenovatieRouteImport.update({
            id: '/renovatie',path: '/renovatie',getParentRoute: () => LangRouteRoute
          })
const LangSitemapRoute = LangSitemapRouteImport.update({
            id: '/sitemap',path: '/sitemap',getParentRoute: () => LangRouteRoute
          })
const LangTechniekenRoute = LangTechniekenRouteImport.update({
            id: '/technieken',path: '/technieken',getParentRoute: () => LangRouteRoute
          })
const LangWarmtepompenAfdekkingenRoute = LangWarmtepompenAfdekkingenRouteImport.update({
            id: '/warmtepompen-afdekkingen',path: '/warmtepompen-afdekkingen',getParentRoute: () => LangRouteRoute
          })
const AuthIndexRoute = AuthIndexRouteImport.update({
            id: '/auth/',path: '/auth/',getParentRoute: () => rootRouteImport
          })
const AuthCallbackRoute = AuthCallbackRouteImport.update({
            id: '/auth/callback',path: '/auth/callback',getParentRoute: () => rootRouteImport
          })
const UploadTokenRoute = UploadTokenRouteImport.update({
            id: '/upload/$token',path: '/upload/$token',getParentRoute: () => rootRouteImport
          })
const LangBlogIndexRoute = LangBlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => LangRouteRoute
          })
const LangBlogSlugRoute = LangBlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => LangRouteRoute
          })
const LangRealisatiesIndexRoute = LangRealisatiesIndexRouteImport.update({
            id: '/realisaties/',path: '/realisaties/',getParentRoute: () => LangRouteRoute
          })
const LangRealisatiesSlugRoute = LangRealisatiesSlugRouteImport.update({
            id: '/realisaties/$slug',path: '/realisaties/$slug',getParentRoute: () => LangRouteRoute
          })
const AuthenticatedAdminAanvragenRoute = AuthenticatedAdminAanvragenRouteImport.update({
            id: '/admin/aanvragen',path: '/admin/aanvragen',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminFeedbackRoute = AuthenticatedAdminFeedbackRouteImport.update({
            id: '/admin/feedback',path: '/admin/feedback',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminFotoInstellingenRoute = AuthenticatedAdminFotoInstellingenRouteImport.update({
            id: '/admin/foto-instellingen',path: '/admin/foto-instellingen',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminFotoOrdenenRoute = AuthenticatedAdminFotoOrdenenRouteImport.update({
            id: '/admin/foto-ordenen',path: '/admin/foto-ordenen',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminFotosRoute = AuthenticatedAdminFotosRouteImport.update({
            id: '/admin/fotos',path: '/admin/fotos',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminGebruikersRoute = AuthenticatedAdminGebruikersRouteImport.update({
            id: '/admin/gebruikers',path: '/admin/gebruikers',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminPagespeedRoute = AuthenticatedAdminPagespeedRouteImport.update({
            id: '/admin/pagespeed',path: '/admin/pagespeed',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminStatistiekenRoute = AuthenticatedAdminStatistiekenRouteImport.update({
            id: '/admin/statistieken',path: '/admin/statistieken',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminVitalsRoute = AuthenticatedAdminVitalsRouteImport.update({
            id: '/admin/vitals',path: '/admin/vitals',getParentRoute: () => AuthenticatedRouteRoute
          })
const ApiPublicAnalyticsRoute = ApiPublicAnalyticsRouteImport.update({
            id: '/api/public/analytics',path: '/api/public/analytics',getParentRoute: () => rootRouteImport
          })
const ApiPublicAnalyticsCronRoute = ApiPublicAnalyticsCronRouteImport.update({
            id: '/api/public/analytics-cron',path: '/api/public/analytics-cron',getParentRoute: () => rootRouteImport
          })
const ApiPublicPageAuditRoute = ApiPublicPageAuditRouteImport.update({
            id: '/api/public/page-audit',path: '/api/public/page-audit',getParentRoute: () => rootRouteImport
          })
const ApiPublicVitalsRoute = ApiPublicVitalsRouteImport.update({
            id: '/api/public/vitals',path: '/api/public/vitals',getParentRoute: () => rootRouteImport
          })
const ApiPublicVitalsRollupRoute = ApiPublicVitalsRollupRouteImport.update({
            id: '/api/public/vitals-rollup',path: '/api/public/vitals-rollup',getParentRoute: () => rootRouteImport
          })
const LangRealisatiesGemeenteGemeenteRoute = LangRealisatiesGemeenteGemeenteRouteImport.update({
            id: '/realisaties/gemeente/$gemeente',path: '/realisaties/gemeente/$gemeente',getParentRoute: () => LangRouteRoute
          })
const AuthenticatedAdminArtikelsIndexRoute = AuthenticatedAdminArtikelsIndexRouteImport.update({
            id: '/admin/artikels/',path: '/admin/artikels/',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminArtikelsSlugRoute = AuthenticatedAdminArtikelsSlugRouteImport.update({
            id: '/admin/artikels/$slug',path: '/admin/artikels/$slug',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminPaginasIndexRoute = AuthenticatedAdminPaginasIndexRouteImport.update({
            id: '/admin/paginas/',path: '/admin/paginas/',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminPaginasSleutelRoute = AuthenticatedAdminPaginasSleutelRouteImport.update({
            id: '/admin/paginas/$sleutel',path: '/admin/paginas/$sleutel',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminRealisatiesIndexRoute = AuthenticatedAdminRealisatiesIndexRouteImport.update({
            id: '/admin/realisaties/',path: '/admin/realisaties/',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminRealisatiesSlugRoute = AuthenticatedAdminRealisatiesSlugRouteImport.update({
            id: '/admin/realisaties/$slug',path: '/admin/realisaties/$slug',getParentRoute: () => AuthenticatedRouteRoute
          })
const ApiPublicBlogImageSplatRoute = ApiPublicBlogImageSplatRouteImport.update({
            id: '/api/public/blog-image/$',path: '/api/public/blog-image/$',getParentRoute: () => rootRouteImport
          })





const LangRouteRouteChildren = {
  LangCookiebeleidRoute: LangCookiebeleidRoute,LangNieuwbouwRoute: LangNieuwbouwRoute,LangOfferteRoute: LangOfferteRoute,LangOpbouwZwembadRoute: LangOpbouwZwembadRoute,LangOverOnsRoute: LangOverOnsRoute,LangPrivacybeleidRoute: LangPrivacybeleidRoute,LangRenovatieRoute: LangRenovatieRoute,LangSitemapRoute: LangSitemapRoute,LangTechniekenRoute: LangTechniekenRoute,LangWarmtepompenAfdekkingenRoute: LangWarmtepompenAfdekkingenRoute,LangIndexRoute: LangIndexRoute,LangBlogSlugRoute: LangBlogSlugRoute,LangRealisatiesSlugRoute: LangRealisatiesSlugRoute,LangBlogIndexRoute: LangBlogIndexRoute,LangRealisatiesIndexRoute: LangRealisatiesIndexRoute,LangRealisatiesGemeenteGemeenteRoute: LangRealisatiesGemeenteGemeenteRoute
}

const LangRouteRouteWithChildren = LangRouteRoute._addFileChildren(LangRouteRouteChildren)




const AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminAanvragenRoute: AuthenticatedAdminAanvragenRoute,AuthenticatedAdminFeedbackRoute: AuthenticatedAdminFeedbackRoute,AuthenticatedAdminFotoInstellingenRoute: AuthenticatedAdminFotoInstellingenRoute,AuthenticatedAdminFotoOrdenenRoute: AuthenticatedAdminFotoOrdenenRoute,AuthenticatedAdminFotosRoute: AuthenticatedAdminFotosRoute,AuthenticatedAdminGebruikersRoute: AuthenticatedAdminGebruikersRoute,AuthenticatedAdminPagespeedRoute: AuthenticatedAdminPagespeedRoute,AuthenticatedAdminStatistiekenRoute: AuthenticatedAdminStatistiekenRoute,AuthenticatedAdminVitalsRoute: AuthenticatedAdminVitalsRoute,AuthenticatedAdminArtikelsSlugRoute: AuthenticatedAdminArtikelsSlugRoute,AuthenticatedAdminPaginasSleutelRoute: AuthenticatedAdminPaginasSleutelRoute,AuthenticatedAdminRealisatiesSlugRoute: AuthenticatedAdminRealisatiesSlugRoute,AuthenticatedAdminArtikelsIndexRoute: AuthenticatedAdminArtikelsIndexRoute,AuthenticatedAdminPaginasIndexRoute: AuthenticatedAdminPaginasIndexRoute,AuthenticatedAdminRealisatiesIndexRoute: AuthenticatedAdminRealisatiesIndexRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,LangRouteRoute: LangRouteRouteWithChildren,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,LlmsDottxtRoute: LlmsDottxtRoute,SitemapDotxmlRoute: SitemapDotxmlRoute,AuthCallbackRoute: AuthCallbackRoute,UploadTokenRoute: UploadTokenRoute,AuthIndexRoute: AuthIndexRoute,ApiPublicAnalyticsRoute: ApiPublicAnalyticsRoute,ApiPublicAnalyticsCronRoute: ApiPublicAnalyticsCronRoute,ApiPublicPageAuditRoute: ApiPublicPageAuditRoute,ApiPublicVitalsRoute: ApiPublicVitalsRoute,ApiPublicVitalsRollupRoute: ApiPublicVitalsRollupRoute,ApiPublicBlogImageSplatRoute: ApiPublicBlogImageSplatRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)